/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/free-certifications-for-developers",
  title: "Free certifications for developers",
  description: `Free certifications for developers.

🧵`,
  image: "/covers/threads/free-certifications-for-developers.png",
  author: "Marko ⚡ Denic"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Marko ⚡ Denic",
      username: "denicmarko",
      avatarUrl: "/avatars/denicmarko.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/denicmarko/status/1455125936807030791"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Free certifications for developers."
      }), _jsx(_components.p, {
        children: "🧵"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/free-certifications-for-developers-1.png`,
      children: [_jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "FreeCodeCamp (by @freecodecamp)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "10 certifications available:"
      }), _jsx(_components.p, {
        children: "~ Responsive Web Design"
      }), _jsx(_components.p, {
        children: "~ JavaScript Algorithms and Data Structures"
      }), _jsx(_components.p, {
        children: "~ Front End Libraries"
      }), _jsx(_components.p, {
        children: "~ Machine Learning"
      }), _jsx(_components.p, {
        children: "~ Data Visualization\n..."
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://www.freecodecamp.org/learn/",
          children: "https://www.freecodecamp.org/learn/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsx(_components.li, {
          children: "Fundamentals of digital marketing (by @Google)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "There are 26 modules to explore, all created by Google trainers, packed full of practical exercises and real-world examples to help you turn knowledge into action."
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://learndigital.withgoogle.com/digitalgarage/course/digital-marketing",
          children: "https://learndigital.withgoogle.com/digitalgarage/course/digital-marketing"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsx(_components.li, {
          children: "Cognitive Class (@CognitiveClass, by @IBM)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Learning paths:"
      }), _jsx(_components.p, {
        children: "~ Blockchain"
      }), _jsx(_components.p, {
        children: "~ Data Science with Python\n..."
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://cognitiveclass.ai/learn",
          children: "https://cognitiveclass.ai/learn"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/free-certifications-for-developers-4.png`,
      children: [_jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsx(_components.li, {
          children: "Test Automation Unversity (by @TestAutomationU)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Free test automation courses with videos, transcripts, quizzes, credits, rank badges, and certificates!"
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://testautomationu.applitools.com/",
          children: "https://testautomationu.applitools.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsx(_components.li, {
          children: "Programming Essentials in Python (by @CiscoNetAcad)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Course includes:"
      }), _jsx(_components.p, {
        children: "~ 8 Modules"
      }), _jsx(_components.p, {
        children: "~ Practice Labs"
      }), _jsx(_components.p, {
        children: "~ Module Quizzes and Module Tests"
      }), _jsx(_components.p, {
        children: "~ Summary Tests"
      }), _jsx(_components.p, {
        children: "~ Final Exam"
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://www.netacad.com/courses/programming/pcap-programming-essentials-python",
          children: "https://www.netacad.com/courses/programming/pcap-programming-essentials-python"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Python Training Course (by @DataFlairWS)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "The course includes:"
      }), _jsx(_components.p, {
        children: "~ 5 real-time projects and 20 complementary projects"
      }), _jsx(_components.p, {
        children: "~ 100+ hrs of study material, practical codes, quizzes, interview guides"
      }), _jsx(_components.p, {
        children: "~ case studies to gain expertise"
      }), _jsx(_components.p, {
        children: "~ certificate"
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://data-flair.training/python-course/",
          children: "https://data-flair.training/python-course/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsx(_components.li, {
          children: "Kaggle (@kaggle)"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Certifications available:"
      }), _jsx(_components.p, {
        children: "~ Machine learning"
      }), _jsx(_components.p, {
        children: "~ Data Visualization"
      }), _jsx(_components.p, {
        children: "~ SQL"
      }), _jsx(_components.p, {
        children: "~ NLP\n..."
      }), _jsxs(_components.p, {
        children: ["Link: ", _jsx(_components.a, {
          href: "https://www.kaggle.com/learn",
          children: "https://www.kaggle.com/learn"
        })]
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "If you're learning to program, be sure to follow me and never miss tips like this."
      })
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
